import { useState } from 'react'
import type { FormEvent } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import api from '../lib/api'
import { useAuthStore } from '../stores/authStore'
import { toastError } from '../lib/toast'
import { PageHeader } from '@/components/page'

export default function ChangePasswordPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const setMustChangePassword = useAuthStore((s) => s.setMustChangePassword)
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()

    if (newPassword !== confirmPassword) {
      toastError('Las contraseñas nuevas no coinciden')
      return
    }
    if (newPassword.length < 8) {
      toastError('La nueva contraseña debe tener al menos 8 caracteres')
      return
    }

    setLoading(true)
    try {
      await api.put('/auth/password', { currentPassword, newPassword })
      setMustChangePassword(false)
      const from = (location.state as { from?: string } | null)?.from
      navigate(from || '/dashboard', { replace: true })
    } catch (err) {
      toastError(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="section-shell flex min-h-[70vh] flex-col items-center justify-center py-12">
      <div className="w-full max-w-md rounded-lg border border-border bg-card p-6">
        <PageHeader
          title="Define tu contraseña"
          description="Tu cuenta se creó con una contraseña temporal. Antes de continuar, define una propia."
        />

        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <div>
            <label htmlFor="currentPassword" className="mb-1 block text-sm font-medium text-foreground">
              Contraseña temporal
            </label>
            <input
              id="currentPassword"
              type="password"
              autoComplete="current-password"
              aria-describedby="currentPasswordHint"
              required
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className="w-full rounded-lg border border-border bg-background px-3 py-2 text-sm text-foreground focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50"
            />
            <p id="currentPasswordHint" className="mt-1 text-xs text-muted-foreground">
              La contraseña temporal con la que se creó tu cuenta.
            </p>
          </div>
          <div>
            <label htmlFor="newPassword" className="mb-1 block text-sm font-medium text-foreground">
              Nueva contraseña
            </label>
            <input
              id="newPassword"
              type="password"
              autoComplete="new-password"
              required
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full rounded-lg border border-border bg-background px-3 py-2 text-sm text-foreground focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50"
            />
          </div>
          <div>
            <label htmlFor="confirmPassword" className="mb-1 block text-sm font-medium text-foreground">
              Confirmar nueva contraseña
            </label>
            <input
              id="confirmPassword"
              type="password"
              autoComplete="new-password"
              required
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full rounded-lg border border-border bg-background px-3 py-2 text-sm text-foreground focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-lg bg-primary px-6 py-2.5 text-sm font-bold text-primary-foreground transition-colors hover:opacity-90 focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50 active:translate-y-px disabled:opacity-60"
          >
            {loading ? 'Guardando...' : 'Guardar y continuar'}
          </button>
        </form>
      </div>
    </div>
  )
}
